type WidgetApi = {
  open?: () => void;
  show?: () => void;
  toggle?: (open?: boolean) => void;
};

/** Opens the embedded ChatX support widget when it is mounted (public landing, logged out). */
export function openSiteWidget(): boolean {
  const w = window as unknown as Record<string, WidgetApi | undefined>;
  const candidates = [
    w.SupportWidget,
    w.TelegramSupportWidget,
    w.TelegramSupportBot,
    w.supportbot,
    w.SupportBot,
    w.telegramSupportBot,
  ];

  for (const api of candidates) {
    if (api && typeof api.open === 'function') {
      api.open();
      return true;
    }
    if (api && typeof api.show === 'function') {
      api.show();
      return true;
    }
    if (api && typeof api.toggle === 'function') {
      api.toggle(true);
      return true;
    }
  }

  const launcher = document.querySelector(
    '#support-widget-iframe, [data-supportbot-open], [id*="support" i][class*="widget" i]'
  ) as HTMLElement | null;
  if (launcher) {
    launcher.click();
    return true;
  }

  return false;
}

function openWithRetry(): void {
  if (openSiteWidget()) return;

  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;
    if (openSiteWidget() || attempts >= 12) {
      window.clearInterval(interval);
    }
  }, 200);
}

/** Delegates clicks on `[data-chatx-open]` to the site support widget. */
export function initChatxOpenButtons(): () => void {
  const onClick = (e: MouseEvent) => {
    const trigger = (e.target as HTMLElement | null)?.closest('[data-chatx-open]');
    if (!trigger) return;
    e.preventDefault();
    openWithRetry();
  };

  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
}
